export default __webpack_public_path__ + "static/media/ic_quick_answer.2304ad41.svg";